import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import JobList from '../components/JobList';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';
import MachineList from '../components/MachineList';
import JobListElement from '../components/JobListElement';
import FlatButton from 'material-ui/FlatButton';

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';

export default
/**
  The dashboard should show the most relevant and actionable information for
  The user.  E.g. if user is running a job, than the job-status should at the
  top of the page.  If there are un-read messages or tasks or similar workflow
  items that needs attending, then the most recent ones should show on the
  dashboard.
  In version one :
  - Running Jobs
  - Machines relevant for the user and their status.
*/
@observer class DashboardPage extends Component {

  refreshData() {
    // Trigger a re-load of the dataset for the dashboard
    AppModel.resetMachineAndJobData();
    AppModelUtils.requireDataset("user_dashboard");
  }

  // Helper function for rendering a running job
  showRunningJob(job) {
    if(!(job.running || job.recentlyActive)) { return null;}
    if(job.timedOut) { return null;}
    return (
      <JobListElement job={job} key={job.key} />
    )
  };
  // Helper function for rendering the list of running jobs, if any
  // Or a message that there are none if not.
  runningJobList() {
    if(AppModel.hasRunningOrRecentAreaJob) {
      return AppModel.jobList.map(this.showRunningJob.bind(this));
    } else {
      return (
        <Card>
          <CardTitle  title={uiMsg('HP_NO_RUNNING',"No running jobs found.")}
                      subtitle={uiMsg('HP_JOBS_LISTED_HERE',
                        "Jobs started by you or your colleagues will be listed here.")}
                        />
          <CardActions>
            <FlatButton label={uiMsg('HP_B_REFRESH_JOBLIST',"Refresh joblist")}
              onTouchTap={this.refreshData.bind(this)} />
          </CardActions>
        </Card>
      )
    }
  };
  showRunningJobs() {
    return (
      <div>
        <List>
          <Subheader>{uiMsg('HP_H_RUNNING',"Your running jobs")}</Subheader>
          {this.runningJobList()}
        </List>
      </div>
      )
  };

  render() {
    // Rendering the JobList page
    return (
      <PageLoading loading={AppModel.fetchingDashboardData}>
          {this.showRunningJobs()}
      </PageLoading>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./src/pages/Dashboard.jsx
 **/